import { z } from 'zod';

import { defaultPagingSchema } from '../../../../helpers/schemas/defaultPagingSchema';
import { EVENT_CATEGORY } from '../../../serviceSettings/EventsPage/const';

import { getClientEventsNewFilterFormSchema } from './getClientEventsNewFilterFormSchema';

const clientEventsNewFilterFormSchema = getClientEventsNewFilterFormSchema();

export const clientEventsNewValidateSearchSchema = defaultPagingSchema.extend({
	category: z.enum(EVENT_CATEGORY).prefault(EVENT_CATEGORY.ALL),
	openedEvent: z.string().optional().catch(undefined),
	filter: clientEventsNewFilterFormSchema.optional().catch(undefined),
});

export type ClientEventsNewValidateSearchSchema = z.infer<
	typeof clientEventsNewValidateSearchSchema
>;
